export function calcCargoDensity(grossWeightKg: number, totalCBM: number): number {
  return totalCBM > 0 ? grossWeightKg / totalCBM : 0;
}

export function calcBreakEvenDensity(dimDivisor: number): number {
  if (dimDivisor <= 0) return 0;
  // density = 1e6 / divisor (kg/m³)
  return 1000000 / dimDivisor;
}

export function classifyFreightClass(densityKgPerCBM: number): string {
  if (densityKgPerCBM <= 0) return 'N/A';
  if (densityKgPerCBM < 100) return 'Light (Volume-driven)';
  if (densityKgPerCBM < 250) return 'Medium';
  if (densityKgPerCBM < 500) return 'Heavy (Weight-driven)';
  return 'Very Heavy';
}
